import { ApplicationConfig, importProvidersFrom, ErrorHandler, inject, provideAppInitializer } from '@angular/core';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling, withPreloading, PreloadAllModules, Router } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';

import { FuseModule } from '@src/@fuse';
import { FuseConfigModule } from '@src/@fuse/services/config';
import { FuseMockApiModule } from '@src/@fuse/lib/mock-api';
import { CoreModule } from '@app/core/core.module';
import { appConfig } from '@app/core/config/app.config';
import { LayoutModule } from '@app/layout/layout.module';
import { appRoutes } from '@app/app.routing';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';

import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCheckboxModule } from "@angular/material/checkbox";

import * as Sentry from "@sentry/angular";

export const applicationConfig: ApplicationConfig = {
    providers: [
        // Router
        provideRouter(
            appRoutes,
            withEnabledBlockingInitialNavigation(),
            withInMemoryScrolling({ scrollPositionRestoration: 'enabled' }),
            withPreloading(PreloadAllModules)
        ),

        // HTTP Client with interceptors from DI
        provideHttpClient(withInterceptorsFromDi()),

        // Animations
        provideAnimations(),

        // Module providers
        importProvidersFrom(
            // Fuse, FuseConfig & FuseMockAPI
            FuseModule,
            FuseConfigModule.forRoot(appConfig),
            // FuseMockApiModule.forRoot(mockApiServices),

            // Core module of your application
            CoreModule,

            // Layout module of your application
            LayoutModule,

            MatProgressBarModule,
            MatSnackBarModule,
            MatCheckboxModule,
        ),

        // Specific providers
        { provide: MAT_DATE_LOCALE, useValue: 'en-NZ' },
        provideMomentDateAdapter(),
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
                showDialog: true,
            }),
        },
        {
            provide: Sentry.TraceService,
            deps: [Router],
        },
        provideAppInitializer(() => {
            // Sentry trace service initializer - simplified for compatibility  
            // This is now a no-op initializer
        }),
    ]
};
